
import { useState } from 'react';

interface VerifiedCreatorBadgeProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

const VerifiedCreatorBadge = ({ size = 'sm', showLabel = false, className = '' }: VerifiedCreatorBadgeProps) => {
  const [hovered, setHovered] = useState(false);

  const sizeConfig = {
    xs: { badge: 'w-4 h-4', icon: 'text-[10px]', label: 'text-[10px]' },
    sm: { badge: 'w-5 h-5', icon: 'text-xs', label: 'text-xs' },
    md: { badge: 'w-6 h-6', icon: 'text-sm', label: 'text-sm' },
    lg: { badge: 'w-8 h-8', icon: 'text-base', label: 'text-sm' },
  };

  const config = sizeConfig[size];

  return (
    <div
      className={`relative inline-flex items-center gap-1 ${className}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className={`${config.badge} rounded-full bg-gradient-to-br from-orange-400 via-rose-500 to-amber-500 flex items-center justify-center shadow-sm cursor-pointer transition-transform hover:scale-110`}
      >
        <i className={`ri-verified-badge-fill text-white ${config.icon}`}></i>
      </div>

      {showLabel && (
        <span className={`font-semibold bg-gradient-to-r from-orange-500 to-rose-500 bg-clip-text text-transparent ${config.label} whitespace-nowrap`}>
          Verified Creator
        </span>
      )}

      {/* Tooltip */}
      {hovered && !showLabel && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 pointer-events-none">
          <div className="bg-gray-900 text-white rounded-lg px-3 py-2 text-xs whitespace-nowrap shadow-lg">
            <div className="flex items-center gap-1.5">
              <i className="ri-verified-badge-fill text-orange-400"></i>
              <span className="font-semibold">Verified AI Drama Creator</span>
            </div>
            <p className="text-gray-300 text-[11px] mt-0.5">Approved creator with publishing privileges</p>
          </div>
          <div className="w-2 h-2 bg-gray-900 rotate-45 mx-auto -mt-1"></div>
        </div>
      )}
    </div>
  );
};

export default VerifiedCreatorBadge;
